import { render, staticRenderFns } from "./TagAutocompleteMultiple.vue?vue&type=template&id=4b88b253&scoped=true"
import script from "./TagAutocompleteMultiple.vue?vue&type=script&lang=js"
export * from "./TagAutocompleteMultiple.vue?vue&type=script&lang=js"
import style0 from "./TagAutocompleteMultiple.vue?vue&type=style&index=0&id=4b88b253&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b88b253",
  null
  
)

export default component.exports